import { Component } from '@angular/core';

import { AuthorizationService } from './../../../../shared/index';
//import { CatalogService } from "./../../index";

@Component({
    selector: 'document-index',
    templateUrl: './document-index.html',
    standalone: false
})

export class DocumentIndexComponent {
    constructor(
        private _authorizationService: AuthorizationService,
        //private _catalogService: CatalogService
    ) { }

    //public isInRole(component: string): boolean {
    //    return this._authorizationService.hasRole(component);
    //}
}
